import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { ReactNode } from 'react';

interface ExportLabelValueProps {
    label: string;
    value: ReactNode;
}

const ExportLabelValue = ({ label, value }: ExportLabelValueProps) => {
    const isString = typeof value === 'string';

    return (
        <Box
            sx={{
                display: 'grid',
                gridTemplateColumns: 'repeat(2, auto)',
                justifyContent: 'start',
                justifyItems: 'start',
                gap: 1,
            }}
        >
            <Typography
                variant='body2'
                sx={{
                    fontWeight: 500,
                    color: 'text.secondary',
                }}
            >
                {label}:
            </Typography>

            {isString ? (
                <Typography
                    variant='body2'
                    sx={{
                        fontWeight: 400,
                        color: 'text.primary',
                        flex: 1,
                    }}
                >
                    {value}
                </Typography>
            ) : (
                value
            )}
        </Box>
    );
};

export default ExportLabelValue;
